import React from 'react';
import type { AiJob } from '../services/aiJobs';
import { isFinished } from '../services/aiJobs';
import './AiJobProgress.css';

const LABELS: Record<string, string> = {
  'validate-batch': '문제 일괄 검증',
  'bulk-analyze': 'AI 일괄 분석',
  'analyze-question': 'AI 문항 분석',
  'classify-domain': 'AI 영역·난이도 분류',
  'quality-review': 'AI 품질 전수 검토',
};

const STATUS: Record<string, string> = {
  queued: '대기 중',
  running: '진행 중',
  succeeded: '완료',
  failed: '실패',
  cancelled: '취소됨',
};

interface Props {
  job: AiJob;
  onCancel?: () => void;
  onDismiss?: () => void;
}

/** 관리자 화면 상단에 붙는 AI 일괄 작업 진행 표시줄 */
const AiJobProgress: React.FC<Props> = ({ job, onCancel, onDismiss }) => {
  const total = job.total || 0;
  const processed = job.counts?.processed || 0;
  const percent = total > 0 ? Math.round((processed / total) * 100) : 0;
  const done = isFinished(job);

  return (
    <div className={`ai-job-progress ai-job-progress--${job.status}`} role="status" aria-live="polite">
      <div className="ai-job-progress__head">
        <strong>{LABELS[job.type] || 'AI 작업'}</strong>
        <span className="ai-job-progress__status">{STATUS[job.status] || job.status}</span>
        <span className="ai-job-progress__count tabular">{processed} / {total}</span>
        <div className="ai-job-progress__actions">
          {!done && onCancel && (
            <button type="button" className="admin-btn sm danger" onClick={onCancel}>취소</button>
          )}
          {done && onDismiss && (
            <button type="button" className="admin-btn sm secondary" onClick={onDismiss}>닫기</button>
          )}
        </div>
      </div>
      <div className="ai-job-progress__bar" aria-hidden="true">
        <span style={{ width: `${percent}%` }} />
      </div>
      <p className="ai-job-progress__meta">
        성공 {job.counts?.succeeded ?? 0} · 실패 {job.counts?.failed ?? 0}
        {job.type === 'validate-batch' && ` · AI 통과 ${job.counts?.aiPassed ?? 0} · 검토 필요 ${job.counts?.reviewRequired ?? 0}`}
        {job.type === 'quality-review' && ` · 사람 확인 필요 ${job.counts?.flagged ?? 0} · 문제 없음 ${job.counts?.clean ?? 0}`}
        {!done && ' · 문항당 30초~2분 걸립니다. 이 화면을 닫아도 작업은 계속됩니다.'}
        {job.error && ` · 오류: ${job.error}`}
      </p>
    </div>
  );
};

export default AiJobProgress;
